import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (...queryKeys: readonly (readonly unknown[])[]) => {
      const invalidations = queryKeys.map((queryKey) =>
        queryClient.invalidateQueries({ queryKey }),
      );

      return Promise.all(invalidations);
    },
    [queryClient],
  );
};
